import React from 'react';
import axios from 'axios';

export const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const formatPrice = (price) => {
  if (!price) return '0';
  return Number(price).toLocaleString('en-GB', { maximumFractionDigits: 0 });
};

export const StatusBadge = ({ status, variants }) => {
  // High-contrast dark-bg + vivid-fg + border treatment for legibility
  // on both white and dark surfaces.
  const presets = {
    success:    { bg: 'bg-emerald-950/95',  text: 'text-emerald-300',  border: 'border-emerald-500/50' },
    verified:   { bg: 'bg-emerald-950/95',  text: 'text-emerald-300',  border: 'border-emerald-500/50' },
    active:     { bg: 'bg-emerald-950/95',  text: 'text-emerald-300',  border: 'border-emerald-500/50' },
    completed:  { bg: 'bg-emerald-950/95',  text: 'text-emerald-300',  border: 'border-emerald-500/50' },
    paid:       { bg: 'bg-emerald-950/95',  text: 'text-emerald-300',  border: 'border-emerald-500/50' },
    warning:    { bg: 'bg-amber-950/95',    text: 'text-amber-300',    border: 'border-amber-500/50' },
    pending:    { bg: 'bg-amber-950/95',    text: 'text-amber-300',    border: 'border-amber-500/50' },
    pending_review: { bg: 'bg-amber-950/95', text: 'text-amber-300',   border: 'border-amber-500/50' },
    deal_completed: { bg: 'bg-amber-950/95', text: 'text-amber-300',   border: 'border-amber-500/50' },
    error:      { bg: 'bg-red-950/95',      text: 'text-red-300',      border: 'border-red-500/50' },
    rejected:   { bg: 'bg-red-950/95',      text: 'text-red-300',      border: 'border-red-500/50' },
    suspended:  { bg: 'bg-red-950/95',      text: 'text-red-300',      border: 'border-red-500/50' },
    failed:     { bg: 'bg-red-950/95',      text: 'text-red-300',      border: 'border-red-500/50' },
    info:       { bg: 'bg-blue-950/95',     text: 'text-blue-300',     border: 'border-blue-500/50' },
    contacted:  { bg: 'bg-blue-950/95',     text: 'text-blue-300',     border: 'border-blue-500/50' },
    gold:       { bg: 'bg-[#0F172A]',       text: 'text-yellow-300',   border: 'border-yellow-500/60' },
    neutral:    { bg: 'bg-slate-900',       text: 'text-slate-300',    border: 'border-slate-500/40' },
  };
  // Translate provided variants (legacy { bg, text }) into preset tokens when possible.
  const v = variants?.[status];
  let preset;
  if (v?.text?.includes('emerald') || v?.text?.includes('green') || v?.bg?.includes('emerald') || v?.bg?.includes('green')) preset = presets.success;
  else if (v?.text?.includes('amber') || v?.bg?.includes('amber')) preset = presets.warning;
  else if (v?.text?.includes('red') || v?.bg?.includes('red')) preset = presets.error;
  else if (v?.text?.includes('blue') || v?.bg?.includes('blue')) preset = presets.info;
  else if (presets[status]) preset = presets[status];
  else preset = presets.neutral;
  return (
    <span
      className={`text-[10px] tracking-wider uppercase font-bold px-2 py-0.5 rounded border ${preset.bg} ${preset.text} ${preset.border}`}
      data-testid={`status-badge-${status}`}
    >
      {String(status).replace(/_/g, ' ')}
    </span>
  );
};

export const CURRENCIES = ['INR', 'USD', 'EUR', 'GBP', 'AED', 'SGD', 'AUD', 'CAD'];
export const CURRENCY_LABELS = { INR: '₹ INR', USD: '$ USD', EUR: '€ EUR', GBP: '£ GBP', AED: 'AED', SGD: 'S$ SGD', AUD: 'A$ AUD', CAD: 'C$ CAD' };

export const COUNTRY_CONFIGS = {
  UK: { currency: 'GBP', symbol: '£', label: 'United Kingdom', flag: '🇬🇧', tenantLaw: 'Tenant Fees Act 2019', fees: { seller: 45, buyer: 20, pro: 25, tenant: 0 } },
  IN: { currency: 'INR', symbol: '₹', label: 'India', flag: '🇮🇳', tenantLaw: 'Platform Access Fee', fees: { seller: 2999, buyer: 999, pro: 1499, tenant: 500 } },
  CA: { currency: 'CAD', symbol: 'C$', label: 'Canada', flag: '🇨🇦', tenantLaw: 'Platform Access Fee', fees: { seller: 55, buyer: 25, pro: 30, tenant: 15 } },
};

export const COUNTRY_FLAGS = { UK: '🇬🇧', IN: '🇮🇳', CA: '🇨🇦', US: '🇺🇸', Other: '🌐' };
export const CURR_SYMBOLS = { gbp: '£', inr: '₹', cad: 'C$', usd: '$' };
